import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {isEmpty, isNil, isNumber} from 'lodash';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss']
})
export class InputNumberComponent implements OnInit {
  @Input()
  set value(value: number) {
    this.model = value;
  }

  @Output() valueChange = new EventEmitter<number>();

  model: string | number = '';

  constructor() {
  }

  ngOnInit(): void {
  }

  onModelChange(input: string | number): void {
    let val = input;
    if (!isNumber(input) && !isEmpty(input)) {
      input = +input.replace(/(,)/g, '');
      if (isNaN(input)) {
        val = val.toString();
      } else {
        val = input;
      }
    }
    this.model = val;
    this.valueChange.emit(isNumber(val) ? val : null);
  }

  onFocusout(): void {
    if (isNil(this.model)) {
      this.model = 0;
    }
  }

  onFocusin(): void {
    if (Number(this.model) === 0) {
      this.model = null;
    }
  }
}
